import { authFetch } from "./authFetch";

const BASE_URL = window.env.API_BASE_URL;

export const getGatewayStatus = async id => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/Status/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      // return null;
      return false;
    } else {
      return true;
    }

    // const gatewayStatus = await response.json();
    // return gatewayStatus;
  } catch (error) {
    return null;
  }
};

export const gethostStatuses = async id => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/HostsStatus/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return [];
    }

    const HostsStatuses = await response.json();

    if (!Array.isArray(HostsStatuses) || HostsStatuses.length === 0) {
      return [];
    }

    return HostsStatuses;
  } catch (error) {
    console.error("Error fetching host statuses:", error);
    return [];
  }
};
